module.exports = __webpack_public_path__ + "static/media/icon-social-twitter.3153693c.svg";